import { ActionType, getType } from 'typesafe-actions';

import { apiActions } from '../api/api.actions';
import { JobType } from '../job/job.types';
import { SeedsState } from './seeds.types';

const INITIAL_STATE: SeedsState = [];

export function seeds(
  state: SeedsState = INITIAL_STATE,
  action: ActionType<typeof apiActions>
): SeedsState {
  switch (action.type) {
    case getType(apiActions.seeds.success): {
      return action.payload;
    }
    case getType(apiActions.updateSeedShared.success): {
      return state.flatMap((seed) => {
        if (seed.job_id !== action.payload.job_id) {
          return [seed];
        }

        if (!action.payload.shared && seed.is_seed) {
          return [];
        }

        // Hiding from library will keep the POG in the current store and mark it private.
        return [{
          ...seed,
          shared: action.payload.shared,
          is_seed: action.payload.shared ? seed.is_seed : false,
        }];
      });
    }
    case getType(apiActions.removePog.success): {
      return state.filter((seed) => seed.job_id !== action.payload.job_id);
    }
    case getType(apiActions.deleteProtoPogPdf.success): {
      return state.filter((seed) => !(
        seed.type === JobType.proto && !seed.job_id && seed.pog_number === action.payload.pogNumber
      ));
    }
    case getType(apiActions.deletePogJob.success): {
      return state.flatMap((seed) => {
        if (seed.job_id !== action.payload.job_id) {
          return [seed];
        }

        return seed.shared ? [{ ...seed, is_seed: true }] : [];
      });
    }
    case getType(apiActions.approveSeed.success): {
      return state.map((seed) =>
        seed.job_id === action.payload.job_id
          ? { ...seed, corp_approved: action.payload.corp_approved }
          : seed
      );
    }
    case getType(apiActions.changePrivateAndSharedPogNames.success): {
      return state.map((seed) =>
        seed.job_id === action.payload.job_id
          ? {
            ...seed,
            pog_name: action.payload.private_pog_name,
            shared_pog_name: action.payload.shared_pog_name,
          }
          : seed
      );
    }
    case getType(apiActions.updateSeedOwnership.success): {
      return state.map((seed) =>
        seed.job_id === action.payload.job_id
          ? { ...seed, corp: action.payload.corp }
          : seed
      );
    }
    default:
      return state;
  }
}
